// tslint:disable: completed-docs
import {
    APP,
    CONTAINER_OPTIONS,
} from 'Constant';
import {
    ICON_CAMERA,
    ICON_CONNECTIVITY,
    ICON_DEVICE_SUPPORT,
    ICON_E_SIM,
    ICON_SCREEN_SIZE,
    ICON_SIM,
    ICON_TOUCH_SCREEN,
} from '@vfde-brix/core';

// Actions
export const CHANGE_COLOR = `${APP}/${CONTAINER_OPTIONS}/CHANGE_COLOR`;
export const CHANGE_CAPACITY = `${APP}/${CONTAINER_OPTIONS}/CHANGE_CAPACITY`;
export const SET_ATOMIC_ID = `${APP}/${CONTAINER_OPTIONS}/SET_ATOMIC_ID`;
export const SET_DEFAULT_STATE = `${APP}/${CONTAINER_OPTIONS}/SET_DEFAULT_STATE`;

// Miscellaneous
export const CAPACITY_KEY = 'sortSize';
export const COLOR_KEY = 'name';

// Technical details icons
export const VLUX_ID_TOP = 2;
export const VLUX_ID_DISPLAY = 6;
export const VLUX_ID_CAMERA = 5;
export const VLUX_ID_MEMORY = 15;
export const VLUX_ID_SIM = 25;
export const VLUX_ID_CONNECTIVITY = 8;
export const VLUX_ID_ENTERTAINMENT = 11;
export const VLUX_ID_HANDLING = 3;
export const VLUX_ID_ORGANIZER = 9;

export const MAP_VLUX_ID_TO_ICON = {
    [VLUX_ID_TOP]: ICON_DEVICE_SUPPORT,
    [VLUX_ID_DISPLAY]: ICON_SCREEN_SIZE,
    [VLUX_ID_CAMERA]: ICON_CAMERA,
    [VLUX_ID_MEMORY]: ICON_E_SIM,
    [VLUX_ID_SIM]: ICON_SIM,
    [VLUX_ID_CONNECTIVITY]: ICON_CONNECTIVITY,
    [VLUX_ID_ENTERTAINMENT]: '',
    [VLUX_ID_HANDLING]: ICON_TOUCH_SCREEN,
    [VLUX_ID_ORGANIZER]: '',
};

// HTML Containers Ids
export const DELIVERY_DATE_CONTAINER = 'hardware-details__delivery-date';
export const DELIVERY_DATE_MOBILE_CONTAINER = 'hardware-details__delivery-date-mobile';
export const COLOR_PICKER_CONTAINER = 'hardware-details__color-option-picker';
export const CAPACITY_PICKER_CONTAINER = 'hardware-details__capacity-option-picker';
export const IMAGE_GALLERY_CONTAINER = 'hardware-details__image-gallery';
